import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from './constants';

export const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    background: COLORS.bgPage,
    overflow: 'hidden',
  },
  tabBar: {
    background: COLORS.white,
    borderBottom: `1px solid ${COLORS.border}`,
    padding: '14px 20px',
    flexShrink: 0,
  },
  tabGroup: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
  },
  tabSeparator: {
    width: 1,
    alignSelf: 'stretch',
    minHeight: 20,
    background: COLORS.border,
    flexShrink: 0,
  },
  tabButton: {
    padding: '8px 20px',
    fontSize: 13,
    fontWeight: 400,
    color: COLORS.muted,
    background: 'transparent',
    cursor: 'pointer',
    transition: 'all .15s',
    whiteSpace: 'nowrap',
    border: 'none',
    borderRadius: 6,
    minHeight: 36,
  },
  tabButtonActive: {
    fontWeight: 600,
    color: COLORS.white,
    background: COLORS.navBg,
  },
  contentArea: {
    flex: 1,
    display: 'flex',
    overflow: 'hidden',
  },
}));
